import { createApp, onMounted } from 'vue'
import { toast, Toaster } from 'vue-sonner'

import VIcon from '/@front:shared/components/v-icon.vue'
import { http } from '/@front:shared/plugins/http'

// info and warning stay plain toasts; toast.info / toast.warning would add an icon and colour.
const toastsByLevel: Record<string, typeof toast.error> = { error: toast.error, success: toast.success }

const handleFlitsMessages = () => {
  const items: { level: string; message: string }[] = window._state.flits || []
  items.forEach((item) => (toastsByLevel[item.level] ?? toast)(item.message))
}

function initializeHeader() {
  createApp({
    name: 'maasland-header',
    components: {
      Toaster,
      'v-icon': VIcon,
    },
    data: () => {
      return {
        showNavigation: false,
        showLanguageNavigation: false,
      }
    },
    methods: {
      toggleNavigation() {
        this.showNavigation = !this.showNavigation
        document.body.classList.toggle('noscroll', this.showNavigation)
      },

      toggleSubNav(event: MouseEvent) {
        const el = (event.target as HTMLElement).closest('li')
        if (!el) {
          return
        }

        const expanded = el.classList.toggle('subnav-active')
        el.querySelector('button')?.setAttribute('aria-expanded', String(expanded))
      },

      toggleLanguageNavigation() {
        this.showLanguageNavigation = !this.showLanguageNavigation
      },

      logout(event: MouseEvent) {
        const target = event.target as HTMLAnchorElement

        http.post(target.href).then(() => {
          location.reload()
        })
      },
    },
    setup() {
      onMounted(() => {
        handleFlitsMessages()
      })
    },
  }).mount('#header-top')
}

/*
 * Chatbase is fetched only once someone asks for the chat. Its script replays the commands
 * queued on window.chatbase.q when it starts, so the open command can be queued before it loads.
 */
function initializeChatbot() {
  const launcher = document.querySelector<HTMLButtonElement>('.chatbot-launcher')

  if (!launcher) {
    return
  }

  launcher.addEventListener(
    'click',
    () => {
      launcher.disabled = true

      const queue: unknown[][] = [['open']]
      window.chatbase = Object.assign(
        (...args: unknown[]) => {
          queue.push(args)
        },
        { q: queue },
      )

      const script = document.createElement('script')
      script.src = 'https://www.chatbase.co/embed.min.js'
      script.setAttribute('chatbotId', launcher.dataset.chatbotId ?? '')
      script.setAttribute('domain', 'www.chatbase.co')
      script.addEventListener('load', () => launcher.remove())
      document.body.append(script)
    },
    { once: true },
  )
}

export const initializeBase = () => {
  initializeHeader()
  initializeChatbot()
}
